<template>
  <div>
    <div class="title">
      <img src="../../../../static/img/login/tip@2x.png" alt="">
      微信未绑定供应商，登录供应商进行自动绑定
    </div>
    <div class="psw_login">
      <el-form :model="form" :rules="loginRules" @submit.native.prevent ref="form">
        <el-form-item prop="userNo">
          <div class="logName_input" @mouseenter="userNoMove" @mouseleave="userNoOut">
            <el-input v-model="form.userNo" placeholder="请输入用户名" @focus="userNoFocus" @input="userNoInput" @blur="userNoBlur" :class="isUserError ? 'user_input_error' : ''">
              <template slot="prefix">
                <div class="userNo_icon"></div>
              </template>
              <template slot="suffix">
                <transition name="shanchu">
                  <div class="user_delete delete_icon" v-show="showUserNoIcon" @click="userNoDelete"></div>
                </transition>
              </template>
            </el-input>
          </div>
        </el-form-item>
        <el-form-item prop="password">
          <div class="psw_input" @mouseenter="pswMove" @mouseleave="pswOut">
            <el-input v-model="form.password" placeholder="请输入密码" :type="isShowPsw ? 'text' : 'password'" @focus="pswFocus" @input="pswInput" @blur="pswBlur" :class="isPswError ? 'psw_input_error' : ''">
              <template slot="prefix">
                <div class="psw_icon"></div>
              </template>
              <template slot="suffix">
                <transition name="shanchu">
                  <div class="delete_icon" v-show="showIcon" @click="pswDelete"></div>
                </transition>
                <div :class="isShowPsw ? 'user_eye_show' : 'user_eye_hide'" @click="isShowPsw = !isShowPsw"></div>
              </template>
            </el-input>
          </div>
        </el-form-item>
        <!-- <button :class="['login',form.userNo && form.password ? 'can_login':'']" @click="login">登录</button> -->
        <button :class="['login']" @click="login">登录</button>
      </el-form>
      <div class="register">
        <div></div>
        注册成为供应商
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    var pswSubmit = (rule, value, callback) => {
      if (!this.form.password) {
        this.isPswError = true
        callback(new Error('请输入'))
      } else {
        this.isPswError = false
        callback()
      }
    };
    var userNoSubmit = (rule, value, callback) => {
      if (!this.form.userNo) {
        this.isUserError = true
        callback(new Error('请输入'))
      } else {
        this.isUserError = false
        callback()
      }
    };
    return {
      form: {
        userNo: "", //账号：ZJWL
        password: "", //密码：abc123
      },
      isShowPsw: false,
      showIcon: false, //是否显示删除图标
      showUserNoIcon: false, //是否显示账号删除图标
      isUserNoFocus: false, //是否聚焦账号输入框
      isPswFocus: false, //是否聚焦密码输入框
      isUserError: false, //账号是否错误
      isPswError: false, //密码是否错误
      weChatID: "",
      openId: "",
      loginRules: {
        userNo: [
          {
            required: true,
            trigger: "submit",
            validator: userNoSubmit,
          },
        ],
        password: [
          {
            required: true,
            trigger: "submit",
            validator: pswSubmit,
          },
        ],
      },
    }
  },
  methods: {
    login() {
      console.log(this.weChatID, "this.weChatID");
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            logName: this.form.userNo,
            pwd: this.form.password,
            unionId: this.weChatID,
            // anonymousId: anonymousId,
            openId: this.openId,
          };
          this.$store
            .dispatch("user/supplierLogin", params)
            .then(({ Message, IsOK, regInfo }) => {
              console.log(IsOK);
              if (!IsOK) {
                this.$message.error(Message)
                if (Message == '该用户不存在！') {
                  this.isUserError = true
                } else {
                  this.isUserError = true
                  this.isPswError = true
                }
              } else {
                // this.$router.push({ path: '/' })
                window.location.href = '/'
              }
              // this.$store.commit("user/DIALOG_VISIBLE", false);
            });
        } else {
          return false
        }
      });
    },
    // 聚焦密码输入框
    pswFocus() {
      this.isPswFocus = true;
      this.isPswError = false
      if (this.form.password) {
        this.showIcon = true;
      } else {
        this.showIcon = false;
      }
    },
    // 失焦密码输入框
    pswBlur() {
      setTimeout(() => {
        this.isPswFocus = false;
        this.showIcon = false;
      }, 100);
    },
    // 移入密码输入框
    pswMove() {
      if (this.form.password && !this.isPswFocus) {
        this.showIcon = true;
      }
    },
    // 移出密码输入框
    pswOut() {
      if (!this.isPswFocus) {
        this.showIcon = false;
      }
    },
    // 监听密码输入框
    pswInput() {
      this.showIcon = this.form.password.length > 0;
    },
    // 清楚密码
    pswDelete() {
      this.form.password = "";
      this.isPswError = false
      this.isPswFocus = false
      this.showIcon = false;
    },
    // 聚焦账号输入框
    userNoFocus() {
      this.isUserNoFocus = true;
      this.isUserError = false;
      if (this.form.userNo) {
        this.showUserNoIcon = true;
      } else {
        this.showUserNoIcon = false;
      }
    },
    // 失焦账号输入框
    userNoBlur() {
      setTimeout(() => {
        this.isUserNoFocus = false;
        this.showUserNoIcon = false;
      }, 100);
    },
    // 移入账号输入框
    userNoMove() {
      if (this.form.userNo && !this.isUserNoFocus) {
        this.showUserNoIcon = true;
      }
    },
    // 移出账号输入框
    userNoOut() {
      if (!this.isUserNoFocus) {
        this.showUserNoIcon = false;
      }
    },
    // 监听账号输入框
    userNoInput() {
      this.showUserNoIcon = this.form.userNo.length > 0;
    },
    // 清楚账号
    userNoDelete() {
      this.form.userNo = "";
      this.isUserError = false
      this.isUserNoFocus = false
      this.showUserNoIcon = false;
    },
  },
}
</script>
<style lang="scss" scoped>
.title {
  height: 32px;
  background: rgba(0, 70, 185, 0.06);
  border-radius: 4px;
  line-height: 32px;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #0046b9;
  display: flex;
  align-items: center;
  img {
    width: 16px;
    height: 16px;
    margin: 0 4px 0 8px;
  }
}
.psw_login ::v-deep .el-form {
  .el-form-item {
    margin: 0;
  }
  .el-form-item__content {
    line-height: 40px;
  }
}
.psw_login ::v-deep .el-input {
  .el-input__inner {
    height: 40px !important;
    background: #ffffff;
    box-shadow: 0px 0px 0px 2px rgba(0, 70, 185, 0);
    border-radius: 8px;
    border: 1px solid #dddddd !important;
    line-height: 40px !important;
    transition: border 0.2s;
    padding: 0 56px 0 40px !important;

    &:hover {
      border: 1px solid #aaaaaa !important;
      transition: border 0.2s;
    }
    &:focus {
      border: 1px solid #0046b9 !important;
      transition: border 0.2s;
    }
  }
  .el-input__suffix {
    right: 0;
  }
  .el-input__suffix-inner {
    display: flex;
    margin: 12px 0;
  }
}
.psw_login ::v-deep .el-input .el-input__inner::placeholder {
  font-size: 14px;
  font-family: AlibabaPuHuiTiR;
  color: #999999;
}
.logName_input
  ::v-deep
  .el-input
  .el-input__inner:focus
  + .el-input__prefix
  .userNo_icon {
  background: url("../../../../static/img/login/ic_login_account_active@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.psw_input
  ::v-deep
  .el-input
  .el-input__inner:focus
  + .el-input__prefix
  .psw_icon {
  background: url("../../../../static/img/login/ic_login_password_active@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
// .psw_login ::v-deep .el-input .el-input__inner:focus
.logName_input {
  margin-top: 16px;
}
.psw_input {
  margin-top: 16px;
}
.userNo_icon {
  width: 36px;
  height: 40px;
  background: url("../../../../static/img/login/ic_login_account_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.psw_icon {
  width: 36px;
  height: 40px;
  background: url("../../../../static/img/login/ic_login_password_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.delete_icon {
  width: 16px;
  height: 16px;
  background: url("../../../../static/img/login/ic_login_delete_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  cursor: pointer;
  &:hover {
    background: url("../../../../static/img/login/ic_login_delete_hover@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
  &:active {
    background: url("../../../../static/img/login/ic_login_delete_click@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
}
.user_delete {
  margin-right: 16px;
}
.user_eye_hide {
  width: 16px;
  height: 16px;
  background: url("../../../../static/img/login/ic_login_show_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  margin: 0 16px 0 8px;
  cursor: pointer;
  &:hover {
    background: url("../../../../static/img/login/ic_login_show_hover@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
  &:active {
    background: url("../../../../static/img/login/ic_login_show_click@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
}
.user_eye_show {
  width: 16px;
  height: 16px;
  background: url("../../../../static/img/login/ic_login_hide_normal@2x.png")
    no-repeat;
  background-size: 16px 16px;
  margin: 0 16px 0 8px;
  cursor: pointer;
  &:hover {
    background: url("../../../../static/img/login/ic_login_hide_hover@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
  &:active {
    background: url("../../../../static/img/login/ic_login_hide_click@2x.png")
      no-repeat;
    background-size: 16px 16px;
  }
}
.psw_login .user_input_error ::v-deep .el-input__inner {
  box-shadow: 0px 0px 0px 2px rgba(216, 63, 63, 0.08) !important;
  border-radius: 8px;
  border: 1px solid #d83f3f !important;
  &::placeholder {
    color: #d83f3f;
  }
  &:hover {
    border: 1px solid #d83f3f !important;
    transition: border 0.2s;
  }
}
.psw_login .user_input_error ::v-deep .el-input__prefix .userNo_icon {
  width: 36px;
  height: 40px;
  background: url("../../../../static/img/login/ic_login_account_error@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.psw_login .psw_input_error ::v-deep .el-input__inner {
  box-shadow: 0px 0px 0px 2px rgba(216, 63, 63, 0.08) !important;
  border-radius: 8px;
  border: 1px solid #d83f3f !important;
  &:hover {
    border: 1px solid #d83f3f !important;
    transition: border 0.2s;
  }
  &::placeholder {
    color: #d83f3f;
  }
}
.psw_login .psw_input_error ::v-deep .el-input__prefix .psw_icon {
  width: 36px;
  height: 40px;
  background: url("../../../../static/img/login/ic_login_password_error@2x.png")
    no-repeat;
  background-size: 16px 16px;
  background-position: center;
  transition: background 0.2s;
}
.login {
  width: 296px;
  height: 40px;
  //   background: rgba(0, 70, 185, 0.3);
  border-radius: 8px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  outline: none;
  border: none;
  //   cursor: not-allowed;
  margin-top: 16px;
  transition: background 0.2s;
  background: linear-gradient(270deg, #0046b9 0%, #2d6dd7 100%)
    rgba(255, 255, 255, 0.64);
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: linear-gradient(270deg, #2973ee 0%, #4f91ff 100%);
    transition: background 0.2s;
  }
  &:active {
    background: linear-gradient(270deg, #0059eb 0%, #2e7cff 100%);
    transition: background 0.2s;
  }
}
.can_login {
  background: linear-gradient(270deg, #0046b9 0%, #2d6dd7 100%)
    rgba(255, 255, 255, 0.64);
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: linear-gradient(270deg, #2973ee 0%, #4f91ff 100%);
    transition: background 0.2s;
  }
  &:active {
    background: linear-gradient(270deg, #0059eb 0%, #2e7cff 100%);
    transition: background 0.2s;
  }
}
.register {
  width: 128px;
  height: 32px;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #dddddd;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #777777;
  margin: 16px auto 0;
  cursor: pointer;
  transition: border, color 0.2s;
  &:hover {
    color: #0046b9;
    border: 1px solid rgba(0, 70, 185, 0.4);
    transition: border, color 0.2s;
    div {
      background: url("../../../../static/img/login/register_hover@2x.png");
      background-size: 100% 100%;
      transition: background 0.2s;
    }
  }
  div {
    width: 16px;
    height: 16px;
    margin: 0 4px 1px 8px;
    background: url("../../../../static/img/login/register.png");
    background-size: 100% 100%;
    transition: background 0.2s;
  }
}
</style>